(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('megafon-internal-phones', {
            parent: 'entity',
            url: '/megafon-internal-phones',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER'],
                pageTitle: 'telestatApp.megafonInternalPhones.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/megafon-internal-phones/megafon-internal-phones.html',
                    controller: 'MegafonInternalPhonesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('megafonInternalPhones');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
